import {Route} from "../../../config/acl/routes/Route";
import {routes} from "../../../config/acl/routes";

export const pathFromRoute = (route: Route): string => routes[route].path;